import { render, staticRenderFns } from "./advertising.vue?vue&type=template&id=6ccfbd04&scoped=true&"
import script from "./advertising.vue?vue&type=script&lang=js&"
export * from "./advertising.vue?vue&type=script&lang=js&"
import style0 from "./advertising.vue?vue&type=style&index=0&id=6ccfbd04&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccfbd04",
  null
  
)

export default component.exports